import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';

export class FiltroWhItemMast {
    codigo: string;
    codigoInterno: string;
    descripcion: string;
    estado: string;
    almacen: string;
    criterio: string;
    item: string;
    condicion:string;

    paginacion: ParametroPaginacionGenerico;

    constructor() {
        this.paginacion = new ParametroPaginacionGenerico();
        this.paginacion.atributoOrdenar = 'item';
    }
}
